import { render } from "./LoadingSpinner.vue?vue&type=template&id=c4305834&scoped=true&ts=true"
import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=c4305834&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4305834"],['__file',"resources/js/vue/components/ui/LoadingSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4305834"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4305834', __exports__)) {
    api.reload('c4305834', __exports__)
  }
  
  module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=c4305834&scoped=true&ts=true", () => {
    api.rerender('c4305834', render)
  })

}


export default __exports__